// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".marT_20[data-v-70424820] {\n  margin-top: 20px;\n}\n[data-v-70424820] .el-descriptions-item__label {\n  white-space: nowrap !important;\n}\n.image_box[data-v-70424820] img {\n  width: 150px;\n}\n", ""]);
// Exports
module.exports = exports;
